/* --------------------------------------------------------------------------------------
   xwToggle.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { useRef, useEffect } from "preact/hooks"
import { MFDApp } from "../../constants/MFDApp.const"

const XwToggle = props => {
    const elementRef = useRef(null)
    const getOptions = props => ({
        ...props,
        initialValue: props.model,
        theme: props.theme || MFDApp.theme,
        change: (event, ui) => props.modelChange(!!ui.value)
    })
    useEffect(() => {
            $(elementRef.current).xrxtoggleswitch(getOptions(props))
        return () => {
            if(!!$(elementRef.current).xrxtoggleswitch()){
                return $(elementRef.current).xrxtoggleswitch("destroy")
            }

        }
    }, [])
    useEffect(()  => 
        {
            return !!$(elementRef.current).xrxtoggleswitch('value') !== props.model ?
                $(elementRef.current).xrxtoggleswitch('value', props.model) : null
        }
    , [props.model])
    return <div ref={elementRef} id={props.id}>
        {props.children}
    </div>
}

export default XwToggle